export default __webpack_public_path__ + "static/media/logo_mycsemanco.051010ec.png";